import { DropdownV2, FormGridV2, InputV2, OptionV2 } from "../FormControlsV2";

export type UserFormV2Errors = {
  profile?: string;
  name?: string;
  phone?: string;
};

type UserFormV2Props = {
  namePrefix: string;
  profile: OptionV2 | null;
  profiles: OptionV2[];
  name: string;
  phone: string;
  errors?: UserFormV2Errors;
  disabled?: boolean;
  profileDisabled?: boolean;
  profileSearchable?: boolean;
  onProfileChange: (profile: OptionV2 | null) => void;
  onNameChange: (name: string) => void;
  onPhoneChange: (phone: string) => void;
};

export function UserFormV2({
  namePrefix,
  profile,
  profiles,
  name,
  phone,
  errors = {},
  disabled = false,
  profileDisabled = false,
  profileSearchable = true,
  onProfileChange,
  onNameChange,
  onPhoneChange,
}: UserFormV2Props) {
  return (
    <FormGridV2>
      <DropdownV2
        name={`${namePrefix}.profile`}
        label="Cargo/Função"
        value={profile}
        options={profiles}
        searchable={profileSearchable}
        disabled={disabled || profileDisabled}
        error={errors.profile}
        onChange={onProfileChange}
      />
      <InputV2
        name={`${namePrefix}.name`}
        label="Nome de Usuário"
        value={name}
        disabled={disabled}
        error={errors.name}
        onChange={onNameChange}
      />
      <InputV2
        name={`${namePrefix}.phone`}
        label="Telefone Celular"
        value={phone}
        type="tel"
        mask="phone"
        disabled={disabled}
        error={errors.phone}
        onChange={onPhoneChange}
      />
    </FormGridV2>
  );
}
